import React from 'react';
import './ReferenceProjects.css';

const ReferenceProjects = () => {
  const projects = [
    {
      name: 'Law and Society Trust Library',
      address: '102/3 Barnes Place, Colombo 7, Sri Lanka',
      link: 'http://62.171.181.112',
      description: 'Complete library automation system with digital cataloguing and circulation management.'
    },
    {
      name: 'D.S. Senanayaka Memorial Public Library',
      address: 'Ahalepola Kumarihami Mawatha, Kandy',
      link: 'http://194.164.150.40',
      description: 'Public library management system with user-friendly interface and comprehensive resource management.'
    }
  ];

  return (
    <section id="reference-projects" className="reference-projects section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Reference Projects</h2>
          <p className="section-subtitle">
            Successful implementations demonstrating our expertise in delivering tailored, scalable, and user-friendly library management systems
          </p>
        </div>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card card">
              <div className="project-header">
                <h3 className="project-name">{project.name}</h3>
                <div className="project-status">
                  <span className="status-badge live">Live</span>
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-details">
                  <div className="detail-item">
                    <span className="detail-icon">📍</span>
                    <div className="detail-content">
                      <h4>Address</h4>
                      <p>{project.address}</p>
                    </div>
                  </div>                
                  
                  <div className="detail-item">
                    <span className="detail-icon">🌐</span>
                    <div className="detail-content">
                      <h4>Website</h4>
                      <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                        {project.link}
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="project-description">
                  <p>{project.description}</p>
                </div>
                
                <div className="project-actions">
                  <a 
                    href={project.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Visit Library
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="projects-summary">
          <div className="summary-content">
            <h3>Project Summary</h3>
            <p>
              These projects demonstrate our ability to deliver tailored, scalable, and user-friendly library management systems. 
              Our solutions support institutions in knowledge dissemination by providing state-of-the-art, scalable solutions 
              that enhance library resources globally.
            </p>
            <div className="summary-features">
              <div className="feature-item">
                <span className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#22c55e"/>
                    <path d="M6.66667 10L9.16667 12.5L13.3333 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span style={{ color: 'white' }}>Tailored Solutions</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#22c55e"/>
                    <path d="M6.66667 10L9.16667 12.5L13.3333 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span style={{ color: 'white' }}>Scalable Systems</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#22c55e"/>
                    <path d="M6.66667 10L9.16667 12.5L13.3333 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span style={{ color: 'white' }}>User-Friendly Interface</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill="#22c55e"/>
                    <path d="M6.66667 10L9.16667 12.5L13.3333 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span style={{ color: 'white' }}>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferenceProjects;


